import './index.scss';
import './overlay.scss';

import SvgIcon from "../../atoms/svgicon";

class SiteHeader {
    constructor(root) {
        this.root = root;

        this.bar = this.root.querySelector('.site-header__bar');

        this.scrollBefore = 0;
        this.scrollOffset = 0;
        this.scrollThreshold = 250;

        window.addEventListener('scroll', this.scroll.bind(this));
        this.scroll();

        this.initOverlay();
    }

    initOverlay() {
        this.overlay = document.createElement('div');
        this.overlay.classList.add('overlay');

        this.container = document.createElement('div');
        this.container.classList.add('container');
        this.overlay.appendChild(this.container);

        this.closeButton = document.createElement('a');
        this.closeButton.setAttribute('href', 'javascript:;');
        this.closeButton.classList.add('close-button');
        this.closeButton.innerHTML = (new SvgIcon()).cross();
        this.closeButton.addEventListener('click', () => {
            this.closeOverlay();
        });
        this.overlay.appendChild(this.closeButton);

        document.body.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                this.closeOverlay();
            }
        });
    }

    /**
     * Opens overlay
     */
    openOverlay(closeCallback, closeMobileHide) {
        this.cleanOverlay();

        this.closeCallback = closeCallback;
        if (closeMobileHide) {
            this.closeButton.classList.add('hide-on-mobile');
        }

        document.body.appendChild(this.overlay);

        setTimeout(() => {
            this.overlay.classList.add('shown');
        }, 100);

        setTimeout(() => {
            window.app.disableScrolling();
        }, 300);

        return this.container;
    }

    closeOverlay() {
        window.app.enableScrolling();

        setTimeout(() => {
            this.overlay.classList.remove('shown');
        }, 100);

        setTimeout(() => {
            if (document.body.contains(this.overlay)) {
                document.body.removeChild(this.overlay);
                this.cleanOverlay();
            }
        }, 300);
    }

    cleanOverlay() {
        if (this.closeCallback instanceof Function) {
            this.closeCallback();
        }

        this.closeCallback = null;

        this.container.innerHTML = '';
        this.closeButton.classList.remove('hide-on-mobile');
    }

    // Mobile Menu

    get isMobileMode() {
        return window.getComputedStyle(this.root).getPropertyValue('--westfleisch-header-mode') === 'mobile';
    }

    get mobileMenuSwitch() {
        return this.root.querySelector('.mb-toolbar .toggle--menu');
    }

    registerMobileMenuToggle(toggleMobileMenuCallback) {
        this.root.querySelector('.mb-toolbar .toggle--menu').addEventListener('click', () => {
            toggleMobileMenuCallback();
        });
    }

    /**
     * Changes mobile burger icon
     */
    set menuShown(newState) {
        if (newState) {
            this.mobileMenuSwitch.classList.add('open');
        } else {
            this.mobileMenuSwitch.classList.remove('open');
        }
    }

    // Scroll

    scroll() {
        let scrollCurrent = window.pageYOffset;
        let scrollDiff = this.scrollBefore - scrollCurrent;

        this.scrollOffset += scrollDiff;
        this.scrollOffset = Math.max(this.scrollOffset, -this.scrollThreshold);
        this.scrollOffset = Math.min(this.scrollOffset, this.scrollThreshold);

        if (this.scrollOffset === -this.scrollThreshold) {
            this.bar.classList.add('compact');
        }

        if (this.scrollOffset === this.scrollThreshold || window.scrollY <= this.scrollThreshold) {
            this.bar.classList.remove('compact');
        }

        this.scrollBefore = scrollCurrent;
    }
}

window.app.run(() => {
    document.querySelectorAll('.site-header').forEach((node) => {
        window.app.siteHeader = new SiteHeader(node);
    });
});
